
import { defineComponent, toRefs } from 'vue';

export default defineComponent({
	props: {
		citationsType: {
			type: Array,
			required: true,
		},
		activeCitationType: {
			type: String,
			required: true,
		},
		callback: {
			type: Function,
			required: true,
		}
	},
	setup (props) {
		const { callback } = toRefs(props);
		
		// Callback function 
		function callbackFn (citation: any) {
			callback.value(citation);
		}

		return { callbackFn }
	}
})
